import React from 'react';
import PropTypes from 'prop-types';

import './styles/radio_button.scss';

const RadioButton = (props) => (
  <label className="radio-row" htmlFor={props.id}>
    <h4>{props.labelCopy}</h4>
    <input
      className="radio-input"
      type="radio"
      name={props.name}
      value={props.valueCopy}
      checked={props.checkedButton === props.valueCopy}
      onChange={props.onChangeFunction}
      id={props.id}
    />
    <span className="radio-dot" />
  </label>
);

RadioButton.propTypes = {
  checkedButton: PropTypes.string.isRequired,
  labelCopy: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChangeFunction: PropTypes.func.isRequired,
  valueCopy: PropTypes.string.isRequired,
  id: PropTypes.string
};

RadioButton.defaultProps = {
  id: null
};

export default RadioButton;
